module.exports = __webpack_public_path__ + "static/img/speed_start.de1f5921.png";